import React from "react"
import MainPage from "../MainPage"
import { useSiteContext } from "../components/common/SiteContext"
import { ContactForm } from "@organic-return/foundation-react/src/components/Forms"
import { graphql, navigate, useStaticQuery } from "gatsby"

export const query = graphql`
  query {
    allListing {
      nodes {
        mlsID
        path
      }
    }
  }
`

const Page404 = ({data}) => {
  const siteContext = useSiteContext();

  const url = typeof window !== 'undefined' ? window.location.pathname : null;
  if(url){
    const urlPathArr = url.toLowerCase().split('/');
    const urlLastPathArr = urlPathArr[urlPathArr.length-1].split('-');
    
    data.allListing.nodes.forEach((value) => {
      if (urlLastPathArr.includes(value.mlsID?.toLowerCase())) {
        value.path && navigate(value.path+window.location.search);
        return
      }
    })
  }

  return (
    <MainPage
      seoProps={{
        title: `Page not Found`,
      }}
    >
        <>
            <h1 className="mt-28">Page Not Found</h1>
            <ContactForm {...siteContext.globalContactFormProps} />
        </>
    </MainPage>
  )
}

export default Page404
